export default "__VITE_ASSET__Da2ORa0u__"